// extracted by mini-css-extract-plugin
export default {"icon":"animatedHamburger_icon__mVNyH","open":"animatedHamburger_open__5mvS2"};